"use strict";

const parseFootnotes = (footnotes, storeId) => footnotes?.map(footnote => typeof footnote === "string" ? footnote : footnote(storeId)).filter(f => typeof f === "string") || [];
export { parseFootnotes };
//# sourceMappingURL=parseFootnotes.mjs.map
